import axiosInstance from "../../../../axiosInstance";
import { HRMS_UTILITY_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserData } from "../../Base/helper/baseFunctions";
import { toast } from "react-toastify";




export const sendOnboardRequestMessageHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/whatsapp/sendOnboardRequestMessage`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: params?.domain || data.domain,
            number: `91${params?.number}`,
            message:params?.message,
            user_empid: data.employee_id,
            emp_id: params?.emp_id,
            info_type: params?.info_type,
            info: "employee"

        }
    })
        .then(res => {
            toast.dismiss();
            toast.success("Request Send Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const sendWhatsAppTextMessageHelper = async (params) => {
    return await axiosInstance(`/whatsapp/sendTextMessage`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            number: `91${params?.number}`,
            name: params?.name || "",
            message: params?.message,
            preview_url: params?.preview_url ?? true,
            domain_name: getDomain()
        }
    })
        .then(res => {
            toast.dismiss();
            params?.show && toast.success(params?.toastMessage || "Message Sent Successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to send message");
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};


